const autoNgTemplateLoaderTemplate1 = require('@/docker/views/containers/edit/container.html');
const autoNgTemplateLoaderTemplate2 = require('@/docker/views/containers/console/attach.html');
const autoNgTemplateLoaderTemplate3 = require('@/docker/views/containers/console/exec.html');
const autoNgTemplateLoaderTemplate4 = require('@/docker/views/containers/create/createcontainer.html');
const autoNgTemplateLoaderTemplate5 = require('@/docker/views/containers/inspect/containerinspect.html');
const autoNgTemplateLoaderTemplate6 = require('@/docker/views/containers/logs/containerlogs.html');
const autoNgTemplateLoaderTemplate7 = require('@/docker/views/containers/stats/containerstats.html');

import { StateRegistry } from '@uirouter/angularjs';
import angular from 'angular';

import { r2a } from '@/react-tools/react2angular';
import { ListView } from '@/react/docker/containers/ListView';

export const containersModule = angular
  .module('portainer.docker.containers', [])
  .component('containersView', r2a(ListView, ['endpoint']))

  .config(config).name;

/* @ngInject */
function config($stateRegistryProvider: StateRegistry) {
  $stateRegistryProvider.register({
    name: 'docker.containers',
    url: '/containers',
    views: {
      'content@': {
        component: 'containersView',
      },
    },
  });

  $stateRegistryProvider.register({
    name: 'docker.containers.container',
    url: '/:id?nodeName',
    views: {
      'content@': {
        templateUrl: autoNgTemplateLoaderTemplate1,
        controller: 'ContainerController',
      },
    },
  });

  $stateRegistryProvider.register({
    name: 'docker.containers.container.attach',
    url: '/attach',
    views: {
      'content@': {
        templateUrl: autoNgTemplateLoaderTemplate2,
        controller: 'ContainerConsoleController',
      },
    },
  });

  $stateRegistryProvider.register({
    name: 'docker.containers.container.exec',
    url: '/exec',
    views: {
      'content@': {
        templateUrl: autoNgTemplateLoaderTemplate3,
        controller: 'ContainerConsoleController',
      },
    },
  });

  $stateRegistryProvider.register({
    name: 'docker.containers.new',
    url: '/new?nodeName&from',
    views: {
      'content@': {
        templateUrl: autoNgTemplateLoaderTemplate4,
        controller: 'CreateContainerController',
      },
    },
  });

  $stateRegistryProvider.register({
    name: 'docker.containers.container.inspect',
    url: '/inspect',
    views: {
      'content@': {
        templateUrl: autoNgTemplateLoaderTemplate5,
        controller: 'ContainerInspectController',
      },
    },
  });

  $stateRegistryProvider.register({
    name: 'docker.containers.container.logs',
    url: '/logs',
    views: {
      'content@': {
        templateUrl: autoNgTemplateLoaderTemplate6,
        controller: 'ContainerLogsController',
      },
    },
  });

  $stateRegistryProvider.register({
    name: 'docker.containers.container.stats',
    url: '/stats',
    views: {
      'content@': {
        templateUrl: autoNgTemplateLoaderTemplate7,
        controller: 'ContainerStatsController',
      },
    },
  });
}
